/**
 * Created by Victor Rojo on 19/10/17.
 */
import { Component, TemplateRef }        from '@angular/core';
import { BsModalService,BsModalRef } from 'ngx-bootstrap/modal';
import { NotificationsService }     from 'angular2-notifications';

import { Subject }      from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {distinctUntilChanged} from 'rxjs/operators';

import { CloudUser }        from "../model/cloudUser";
import { CloudUserService } from "../profile/cloudUser.service";
import { I18NService }      from "../shared/i18n/i18n.service";

@Component({
  templateUrl: './cloudUser-list.component.html',
  styleUrls: [ './cloudUser-list.component.css'],
})
export class CloudUserListComponent {
  data: CloudUser[] = [];
  rows: any;
  selected: any[] = [];
  modalRef: BsModalRef;
  isLoading = true;
  private searchText= '';
  private searchTerms = new Subject<string>();
  tableMessages: any;

  constructor(private cloudUserService: CloudUserService,
              private modalService: BsModalService,
              private i18nService: I18NService,
              private notificationService: NotificationsService) {

    this.cloudUserService.list()
      .then( list => {
        this.data = list;
        this.filterRows();
        this.isLoading = false;
      })
      .catch( error => {
        this.data = [];
        this.filterRows();
        this.isLoading = false;
        this.notificationService.error(
          this.i18nService.get("error"),
          this.i18nService.get("cantGetUserData")
        );
      });

    this.searchTerms
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((result) => {
        this.searchText = result.toUpperCase();
        this.filterRows();
      });

    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tableMessages.totalMessage = this.i18nService.get("total");
    this.tableMessages.selectedMessage = this.i18nService.get("selected");
  }

  onSearch(term: string){
    this.searchTerms.next(term);
  }

  onSelect({ selected }:any) {

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  filterRows(): void {
    this.rows = this.data.filter( row => {
      return this.searchFilter(row);
    })
  }

  showDeleteModal(template: TemplateRef<any>): void {
    if ( this.selected.length ) {
      this.modalRef = this.modalService.show(template);
    }
  }

  confirmDelete(): void {
    this.selected.forEach( cloudUser => {
      this.cloudUserService
        .delete(cloudUser.idCloudUser)
        .then( res => {
          this.data = this.data.filter( row =>  {
            return row.idCloudUser != cloudUser.idCloudUser
          });
          this.selected.splice(0, this.selected.length);
          this.filterRows();
          this.notificationService.success(
            this.i18nService.get("success"),
            this.i18nService.get("itemsDeleted")
          );
        })
        .catch( error => {
          this.notificationService.error(
            this.i18nService.get("error"),
            this.i18nService.get("cantDeleteItems")
          );
        })
    });
    this.modalRef.hide();

  }

  private searchFilter(row: any){
    return ( !this.searchText || row.userName.toUpperCase().indexOf(this.searchText) != -1
    || row.login.toUpperCase().indexOf(this.searchText) != -1
    || row.emailAddress.toUpperCase().indexOf(this.searchText) != -1);
  }
}
